__turbopack_context__.v({
  "redesSociais": "bNhZ7q_redesSociais",
});
